module.exports = __webpack_public_path__ + "img/mirkal.56b8a288.png";